import { isTst1 } from '../lib/environment';
import { isNilOrEmpty } from '../lib/utils';
const CHATNITE_AUTH_URL = isTst1
    ? 'https://chatnite-test.spotify.net/graphql'
    : 'https://chatnite.spotify.com/graphql';
const CHATNITE_UNAUTH_URL = isTst1
    ? 'https://chatnite-unauth-test.spotify.net/graphql'
    : 'https://chatnite-unauth.spotify.com/graphql';
export const AUTH_ENDPOINT = !isNilOrEmpty(process.env.NEXT_PUBLIC_CHATNITE_ENDPOINT)
    ? process.env.NEXT_PUBLIC_CHATNITE_ENDPOINT
    : CHATNITE_AUTH_URL;
export const UNAUTH_ENDPOINT = !isNilOrEmpty(process.env.NEXT_PUBLIC_CHATNITE_ENDPOINT)
    ? process.env.NEXT_PUBLIC_CHATNITE_ENDPOINT
    : CHATNITE_UNAUTH_URL;
//# sourceMappingURL=endpoints.js.map